import type { PublicUser } from './types.js';

/**
 * Access-токен живёт только в памяти вкладки. В localStorage его класть нельзя:
 * долговременное хранение — задача httpOnly-cookie с refresh-токеном (01-SPEC.md §7).
 * Поэтому после перезагрузки страницы сессия восстанавливается запросом
 * `/auth/refresh`, а не чтением из хранилища.
 */
let accessToken: string | null = null;
let currentUser: PublicUser | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setSession(token: string | null, user: PublicUser | null): void {
  accessToken = token;
  currentUser = user;
}

export function getCurrentUser(): PublicUser | null {
  return currentUser;
}

export function clearSession(): void {
  accessToken = null;
  currentUser = null;
}
